/**
 * Plush wishlist — a self-contained wishlist with no app required.
 *
 * Saved products live in localStorage as an array of product handles. The heart
 * button on each product card toggles membership; the header icon shows a count;
 * the /pages/wishlist page renders the saved products by fetching each product's
 * card markup from its product page.
 *
 * Limitation: localStorage is per-browser, so a wishlist does not follow a
 * customer across devices or sign-in. Swap in an app later if that matters.
 */
(function () {
  'use strict';

  var KEY = 'plush:wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage full or blocked — fail silently */
    }
    updateCount();
    document.dispatchEvent(new CustomEvent('plush:wishlist:change', { detail: { list: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function updateCount() {
    var count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function paintButton(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function bindButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-wishlist-toggle');
      if (!handle) return;
      paintButton(button, has(handle));
      if (button.dataset.plushBound === '1') return;
      button.dataset.plushBound = '1';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        paintButton(button, toggle(handle));
      });
    });
  }

  // Expose a tiny API for the wishlist page section.
  window.PlushWishlist = { read: read, has: has, toggle: toggle, bind: bindButtons };

  function init() {
    updateCount();
    bindButtons(document);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-bind when sections re-render (filtering, quick add, variant changes).
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      bindButtons(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
